import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {MarketplaceCarousel} from '../Marketplace';
import ClosestBrandRetailer from '../../components/ClosestBrandRetailer';
import Api from '../../Api';
import {US_ISO, MAKER_ATTRIBUTE_TO_ICON, ATTRIBUTES_VALUE_TO_NAME} from '../../consts';
import {capitalizeEveryWord, simplifyLargeNumber} from '../../lib/StringUtils';
const {Utils} = Api;

import viewAllArrow from '../../images/maker/view-all-arrow.svg';
import './styles.less';

function createMapping(brands, products) {
  const brandTokens = Object.keys(brands);
  const productTokens = Object.keys(products);
  return brandTokens.reduce((mapping, brandToken) => {
    const brandProductTokens = productTokens.filter(productToken => products[productToken].brand_token === brandToken);
    mapping[brandToken] = brandProductTokens.reduce((productMap, productToken) => {
      productMap[productToken] = products[productToken];
      return productMap;
    }, {});

    return mapping;
  }, {});
}

class MakerRecommendation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closestBrandRetailer: null
    }
  }

  static propTypes = {
    classNames: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)]),
    brand: PropTypes.object,
    displayOrder: PropTypes.array,
    products: PropTypes.object,
    alignLeft: PropTypes.bool,
    selectBrand: PropTypes.func,
    retailerToken: PropTypes.string.isRequired,
    generateProductUrl: PropTypes.func
  };

  static defaultProps = {
    alignLeft: true
  };

  componentWillMount() {
    Api.getClosestBrandRetailer(this.props.brand.token)
      .then(closestBrandRetailer => {
          this.setState({closestBrandRetailer});
        }
      );
  }

  render() {
    const products = this.props.products;
    const brand = this.props.brand;

    const brandBackgroundStyle = (brand.images && brand.images[0] && brand.images[0].url)
      ? {backgroundImage: `url(${brand.images[0].url})`}
      : {backgroundColor: 'grey'};

    const instagramView = brand.instagram_handle
      ? <Link to={`https://instagram.com/${brand.instagram_handle}`} target="_blank">
        <div className="instagram">
          <div className="icon"/>
          {brand.instagram_followers
            ? <div className="followers">{simplifyLargeNumber(brand.instagram_followers)}</div>
            : null}
        </div>
      </Link>
      : null;

    const madeInView = brand.made_in === US_ISO && (brand.made_in_city || brand.made_in_state)
      ? <div className="location">{brand.made_in_city || brand.made_in_state}</div>
      : null;

    const min_order_dollars = Utils.formatCents(brand.minimum_order_amount_cents, true);
    const min_order_string = min_order_dollars
      ? `Maker Minimum $${min_order_dollars}`
      : 'No Minimum';

    const closestBrandRetailerView = this.state.closestBrandRetailer
      ? <ClosestBrandRetailer distance={this.state.closestBrandRetailer}
                              brandName={brand.name}/>
      : null;

    let applicableAttributes = Object.keys(MAKER_ATTRIBUTE_TO_ICON).filter(attribute => !!brand[attribute]);
    if (brand.made_in === US_ISO) {
      applicableAttributes.push('made_in_usa');
    }
    const attributeView = applicableAttributes.length > 0
      ? <div className="attributes">
        {applicableAttributes.map(attribute => {
          const attributeData = MAKER_ATTRIBUTE_TO_ICON[attribute];
          const attributeText = capitalizeEveryWord(ATTRIBUTES_VALUE_TO_NAME[attribute], true);
          return <div key={attribute}><img role="presentation"
                                           style={{height: attributeData.height}}
                                           src={attributeData.icon}/>{attributeText}</div>
        })}</div>
      : null;

    const classNames = ['maker-recommendation-component']
      .concat(this.props.alignLeft ? 'left' : 'right')
      .concat(this.props.classNames);

    const brandUrl = `/retailer/${this.props.retailerToken}/brand/${this.props.brand.token}`;

    return (
      <div className={classNames.join(' ')}>
        <div className="maker">
          <div className="maker-header">
            <div className="maker-image-container">
              <Link to={brandUrl} className="maker-image" style={brandBackgroundStyle}/>
              {instagramView}
            </div>
            <div className="maker-info">
              <div className="padding-wrapper">
                <Link className="maker-title" to={brandUrl}>
                  <div className="title-bar">
                    <div className="title">{brand.name}</div>
                    {madeInView}
                    <div className="minimum">{min_order_string}</div>
                  </div>
                  {madeInView}
                </Link>
                <div className="description">{brand.description}</div>
                <div className="anchor">
                  {closestBrandRetailerView}
                  <div
                    className={`attributes-view-all-container ${applicableAttributes.length === 0 ? 'no-attributes' : ''}`}>
                    {attributeView}
                    <div className="view-all-cta">
                      <Link to={brandUrl}>View All Items<img role="presentation" src={viewAllArrow}/></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="carousel-container">
          <MarketplaceCarousel products={products}
                               brands={brand}
                               minimize={true}
                               displayOrder={this.props.displayOrder}
                               selectBrand={this.props.selectBrand}
                               generateProductUrl={this.props.generateProductUrl}
                               retailerToken={this.props.retailerToken}
                               selectCollection={this.props.selectCollection}/>
        </div>
      </div>
    );
  }
}


export default class MakerRecommendationsList extends React.Component {
  static propTypes = {
    brands: PropTypes.object.isRequired,
    products: PropTypes.object.isRequired,
    retailerToken: PropTypes.string.isRequired,
    selectBrand: PropTypes.func,
    generateProductUrl: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
  }

  componentWillMount() {
    Api.startListen(this, 'user', Api.cache.eventTypes.USER_CHANGED);
  }

  componentDidMount() {
    Api.getUser(true).then(
      (user) => {
        this.setState({user: user});
      }
    );
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.USER_CHANGED);
  }

  render() {
    const brandProductMapping = createMapping(this.props.brands, this.props.products);
    const isEmployee = this.state.user && this.state.user.is_employee;
    const brandKeys = Object.keys(this.props.brands);
    let brandTokens = isEmployee
      ? brandKeys
      : brandKeys.filter(token => {
        const brand = this.props.brands[token];
        return brand.images && brand.images.length > 0 && brand.images[0].url;
      });

    if (brandTokens.length === 0) {
      return <div className="no-results">
        <h1>No Products</h1>
        <p>Email us at <a href="mailto:contact@indigofair.com">contact@indigofair.com</a> to get your custom
          recommendations!</p>
      </div>;
    }

    return (
      <div className="maker-recommendations-list">
        {brandTokens
          .filter(brandToken => {
            const products = brandProductMapping[brandToken];
            return products && Object.keys(products).length > 0;
          })
          .map((brandToken, index) => {
            const brandProducts = brandProductMapping[brandToken];
            const displayOrder = Object.keys(brandProducts);
            return <MakerRecommendation key={brandToken}
                                        brand={this.props.brands[brandToken]}
                                        retailerToken={this.props.retailerToken}
                                        products={brandProducts}
                                        displayOrder={displayOrder}
                                        alignLeft={(index + 1) % 2 !== 0}
                                        generateProductUrl={this.props.generateProductUrl}
                                        selectBrand={this.props.selectBrand}/>
          })}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/MakerRecommendations/index.jsx
 **/